<template>
  <div ref="content" class="content">
    <!-- 正文 -->
    <div v-if="contentData.type === 19" class="video-content">
      <video
        controls
        preload="metadata"
        :src="contentData.video_format.video"
        :poster="contentData.video_format.cover"
      ></video>
    </div>
    <wiki-editor-renderer :editorData="editorData"></wiki-editor-renderer>
  </div>
</template>

<script>
// plugins
import eventBus from "@/plugins/eventBus";
// components
import WikiEditorRenderer from "@/views/editor/wiki-editor/wiki-editor-renderer.jsx";
// detail plugins
import wikiEntryToLink from "../plugins/wikiEntryToLink";

export default {
  name: "DetailJsonContent",
  components: {
    WikiEditorRenderer
  },
  props: {
    contentData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      detail: {}
    };
  },
  computed: {
    editorData() {
      const content_json = this.contentData.content_json;
      return content_json ? JSON.parse(content_json) : [];
    }
  },
  created() {},
  mounted() {
    // 预览图片
    const imgs = this.$refs.content.querySelectorAll(".preview-image");
    Array.prototype.forEach.call(imgs, (img, index) => {
      img.addEventListener("click", () => {
        this.handleImgPreview(imgs, index);
      });
    });

    // 处理富文本中所有的链接文本并将其转为链接
    this.convertTextToLink(this.$refs.content);
    // 将标题转为目录
    this.handleCatalog();
    // 将内容为wiki词条的转为链接
    setTimeout(() => {
      if (!["www"].includes(this.alias) && this.contentData.entry_auto === 1) {
        wikiEntryToLink(this.$refs.content, this.alias, this.$route.params.id);
      }
    }, 100);
  },
  methods: {
    // 图片预览
    handleImgPreview(imgs, index) {
      const urls = Array.prototype.map.call(imgs, img => img.src);
      this.$imgViewShow(urls, index);
    },
    // 将标题转为目录
    handleCatalog() {
      let cataList = [];
      let oneLevelLen = 0;
      let secondLevelLen = 0;
      let startlevel = 1;
      // 为标题增加目录id
      const contentDom = this.$refs.content;
      const headerList = contentDom.querySelectorAll(
        ".wiki-editor-content > h1, .wiki-editor-content > h2, .wiki-editor-content > h3, .wiki-editor-content > h4, .wiki-editor-content > h5, .wiki-editor-content >h6"
      );

      const list = Array.prototype.map.call(headerList, (item, index) => {
        item.setAttribute("id", `catalog-${index}`);
        const title = item.innerText;
        let level = 1;
        if (item.tagName == "H1") {
          level = 1;
        } else if (item.tagName == "H2") {
          level = 2;
        } else if (item.tagName == "H3") {
          level = 3;
        } else if (item.tagName == "H4") {
          level = 4;
        } else if (item.tagName == "H5") {
          level = 5;
        }
        return {
          level,
          title
        };
      });

      startlevel = Math.min(...list.map(it => it.level));
      // 下一级
      const nextLevel = Math.min(...list.filter(it => it.level > startlevel).map(it => it.level));
      list.forEach((item, index) => {
        if (!item.title.trim()) return;
        // 取相邻级别标题
        if (startlevel === item.level) {
          oneLevelLen++;
          cataList.push({
            oneLevelLen: oneLevelLen,
            secondLevelLen: 0,
            title: item.title,
            dataId: "#catalog-" + index
          });
        }
        // 下级
        if (nextLevel === item.level) {
          secondLevelLen++;
          cataList.push({
            oneLevelLen: oneLevelLen,
            secondLevelLen: secondLevelLen,
            title: item.title,
            dataId: "#catalog-" + index
          });
        }
      });

      setTimeout(() => {
        if (cataList.length) {
          eventBus.$emit("setCataVisible", true);
          eventBus.$emit("setCataList", cataList);
        } else {
          eventBus.$emit("setCataVisible", false);
          eventBus.$emit("setCataList", []);
        }
      });
    },
    // 遍历DOM树中的所有节点，将文本节点中包含链接地址的文本转换为链接
    convertTextToLink(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        // 如果节点是文本节点
        const text = node.textContent;
        const regex = /(https?:\/\/[^\s]+)/g; // 正则表达式匹配链接地址
        const replacedText = text.replace(regex, '<a href="$1">$1</a>'); // 将匹配到的链接地址替换为链接
        if (replacedText !== text) {
          const fragment = document.createRange().createContextualFragment(replacedText);
          node.parentNode.replaceChild(fragment, node);
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // 如果节点是元素节点，则递归处理其子节点
        for (let i = 0; i < node.childNodes.length; i++) {
          this.convertTextToLink(node.childNodes[i]);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.video-content {
  width: 100%;
  margin-bottom: 20px;
  video {
    width: 100%;
    object-fit: cover;
  }
}
</style>
